import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ImpersonationLoginOldPortalResponse extends BackendResponse {
  /** redirect url to cvp1 autologin.aspx */
  item: string;
}

export interface ImpersonationLoginOldPortalParameters extends NextApiParams {
  k: string;
  candidateId: number;
}

export const impersonationLoginOldPortal = withNextApi<
  ImpersonationLoginOldPortalResponse,
  ImpersonationLoginOldPortalParameters
>("/auth/ImpersonationLoginOldPortal", {
  method: "GET",
});
